export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-4 md:px-5 py-2 rounded-full">
              <div className="w-2 h-2 bg-[#0D9488] rounded-full"></div>
              <span className="text-[#0D9488] font-semibold text-xs md:text-sm">Quiénes Somos</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E]">
              Sobre <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D9488] to-[#0F766E]">F&amp;A Digital</span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              Somos especialistas en evaluación automatizada mediante tecnología OMR, brindando soluciones precisas y confiables para instituciones educativas que procesan grandes volúmenes de evaluaciones.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              Nuestra experiencia en calificación automatizada nos permite ofrecer un servicio que combina precisión, rapidez y seguridad, eliminando errores humanos y optimizando tiempos de procesamiento.
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-8 pt-6 md:pt-8">
              <div className="space-y-1 md:space-y-2 border-l-4 border-[#F59E0B] pl-3 md:pl-6">
                <p className="text-3xl md:text-5xl font-bold text-[#1A1A2E]">15,000+</p>
                <p className="text-xs md:text-base text-gray-500 font-medium">Evaluaciones Procesadas</p>
              </div>
              <div className="space-y-1 md:space-y-2 border-l-4 border-[#0D9488] pl-3 md:pl-6">
                <p className="text-3xl md:text-5xl font-bold text-[#1A1A2E]">98%</p>
                <p className="text-xs md:text-base text-gray-500 font-medium">Satisfacción del Cliente</p>
              </div>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#0D9488]/20 to-[#F59E0B]/20 rounded-3xl blur-xl"></div>
            <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="absolute top-4 md:top-6 left-4 md:left-6 bg-gradient-to-r from-[#0D9488] to-[#0F766E] text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold z-10">
                Desde 2020
              </div>
              <img 
                src="https://public.readdy.ai/ai/img_res/c263a3c7e64eb1855abf1e1cbc30e84b.jpg" 
                alt="Análisis de datos educativos" 
                className="w-full h-[280px] md:h-[400px] object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}